<template>
  <transition name="fade" mode="out-in">
    <span :key="text">
      {{ text }}
    </span>
  </transition>
</template>

<script>
export default {
  props: {
    text: {
      type: [String, Number],
    },
  }
};
</script>

<style lang="stylus">
.fade-enter-active,
.fade-leave-active
  transition all 50ms

.fade-enter,
.fade-leave-to
  opacity 0

</style>
